/* eslint-disable  @typescript-eslint/no-explicit-any */

interface PaginationResult<T> {
  content: Array<T>;
  page: {
    size: number;
    number: number;
    totalElements: number;
    totalPages: number;
  };
}

const defaultResults = (): PaginationResult<any> => {
  return {
    content: [],
    page: {
      size: 15,
      number: 0,
      totalElements: 0,
      totalPages: 0
    }
  };
};

export { PaginationResult, defaultResults };
